import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PowerSupplyImage from '../../../Image/PowerSupply.png';
import InfoIcon from '@mui/icons-material/Info';

const BntMoreSupply = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Componente auxiliar para cada box de informação
  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0,
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            overflow: 'hidden',
            width: '100%',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          Power Supply
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh', // Scroll vertical
          }}
        >
          {/* Imagem em cima */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img
              src={PowerSupplyImage}
              alt="Power Supply"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>

          {/* Grid com 2 colunas */}
          <Grid container spacing={3}>
            {/* Coluna 1 */}
            <Grid item xs={6}>
              <InfoBox title="PSU Power">
                • 30W on 5VDC rail <br />
                • 110W on 12VDC rail <br />
                • 40W on 30VDC
              </InfoBox>

              <InfoBox title="Features">
                • High efficiency & low ripple <br />
                • Complete isolation power conversion <br />
                • Input RLCL <br />
                • Input UVP and OVP protection circuits <br />
                • Secondary side UVP <br />
                • Hot redundancy <br />
                • Parallel configuration available
              </InfoBox>
            </Grid>

            {/* Coluna 2 */}
            <Grid item xs={6}>
              <InfoBox title="Front Panel Interfaces">
                D-SUB15 Pin Plug for 28V Power In
              </InfoBox>

              <InfoBox title="Back Panel Interfaces">
                ADHA P1 connector for power delivery
              </InfoBox>

              <InfoBox title="Power Budgets">
                • Input Voltage: 28V <br />
                • Maximum Power dissipation: 34W
              </InfoBox>

              <InfoBox title="Mechanical Budgets">
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: 350 grams
              </InfoBox>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntMoreSupply;
